import React from "react";
import styles from "./AdvertisementSection.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import homepageAdvertisement1 from "../../../assets/images/homepage-hero1.jpg";
import homepageAdvertisement2 from "../../../assets/images/homepage-hero2.jpg";
import homepageAdvertisement3 from "../../../assets/images/homepage-hero3.jpg";

const AdvertisementSection = () => {
  return (
    <div className={styles.homepageAdvertisementSection}>
      <Swiper
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        // autoplay={{
        //   delay: 4000,
        //   disableOnInteraction: false,
        // }}
        className="homepageHeroSwiper"
      >
        <SwiperSlide>
          <div className={styles.advertisementSectionContainer}>
            <div className={styles.advertisementLeft}>
              <div>
                <h1>What is Lorem Ipsum?</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
                <button>Read More</button>
              </div>
            </div>
            <div className={styles.advertisementRight}>
              <img src={homepageAdvertisement1} alt="Advertisement1" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.advertisementSectionContainer}>
            <div className={styles.advertisementLeft}>
              <div>
                <h1>What is Lorem Ipsum?</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
                <button>Read More</button>
              </div>
            </div>
            <div className={styles.advertisementRight}>
              <img src={homepageAdvertisement2} alt="Advertisement2" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.advertisementSectionContainer}>
            <div className={styles.advertisementLeft}>
              <div>
                <h1>What is Lorem Ipsum?</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
                <button>Read More</button>
              </div>
            </div>
            <div className={styles.advertisementRight}>
              <img src={homepageAdvertisement3} alt="Advertisement3" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default AdvertisementSection;
